






import { Component, Prop, Vue } from 'vue-property-decorator';
import { PageRefBlockDto } from '@/api';
import PageTeaser from '@/views/cms/snippet/PageTeaser.vue';

@Component({
  components: {PageTeaser},
})
export default class PageRefBlock extends Vue {
  @Prop({required: true})
  public readonly model!: PageRefBlockDto;
}
